import { render, staticRenderFns } from "./Gdpr.vue?vue&type=template&id=2813ce90&scoped=true"
import script from "./Gdpr.vue?vue&type=script&lang=js"
export * from "./Gdpr.vue?vue&type=script&lang=js"
import style0 from "./Gdpr.vue?vue&type=style&index=0&id=2813ce90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2813ce90",
  null
  
)

export default component.exports